import { render, staticRenderFns } from "./servicePages.vue?vue&type=template&id=e95e3e38&"
import script from "./servicePages.vue?vue&type=script&lang=js&"
export * from "./servicePages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports